import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsRefreshNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4 24C4 12.954 12.954 4 24 4c7.806 0 14.571 4.473 17.866 11H34v3h10.5a2.5 2.5 0 002.5-2.5V5h-3v7.635C40.044 5.687 32.57 1 24 1 11.297 1 1 11.297 1 24s10.297 23 23 23 23-10.297 23-23h-3c0 11.046-8.954 20-20 20S4 35.046 4 24z"
        fill=""
      />
    </svg>
  )
);
SvgActionsRefreshNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsRefreshNormalLarge;
